export class GetGdsgDevStatsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "observedAtMs",
            "baseName": "observedAtMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<GdsgDevStats>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetGdsgDevStatsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
